import { api } from '../lib/api';

export interface AuditActor {
  id: string;
  name: string;
  email: string;
}

export interface AuditEntryView {
  id: string;
  actor: AuditActor | null;
  onBehalfOf: AuditActor | null;
  action: string;
  entityType: string;
  entityId: string;
  before: unknown;
  after: unknown;
  reason: string | null;
  occurredAt: string;
}

export function listAuditHistory(entityType: string, entityId: string): Promise<AuditEntryView[]> {
  return api<AuditEntryView[]>(`/audit?entityType=${encodeURIComponent(entityType)}&entityId=${encodeURIComponent(entityId)}`);
}
